import { QueryOptions } from "../components/Common/useQuery";
import useUserQuery from "../components/Common/useUserQuery";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";

interface TicketImageResponse {
  ticketImageUri: string
}

const useGetTicketImage = (orderTransactionId: string, options?: QueryOptions<TicketImageResponse>) => {
  const business = useSelectedBusiness();
  return useUserQuery<TicketImageResponse>({ path: `api/businesses/${business.id}/orderTransactions/${orderTransactionId}/ticketImage` }, options);
}

export default useGetTicketImage;
